import { createContext } from "react";

import type { DirectDocumentBudget } from "./useDirectDocumentBudget";

export const DirectDocumentBudgetContext =
    createContext<DirectDocumentBudget | null>(null);
